<template>
  <div>
    <div class="row">
      <div class="col s12">
        <p>
          <ul class="tabs" ref="tabs">
              <li class="tab s5"><a class="active" href="#body">Body</a></li>
              <li class="tab s5"><a href="#training">Train</a></li>
              <li class="tab s5"><a href="#info">Info</a></li>
          </ul>
        </p>
      </div>
      <BodyShape id="body" class="col s12" :user="user" />
      <Training id="training" class="col s12" :user="user" />
      <Infos id="info" class="col s12" :user="user" />
    </div>
  </div>
</template>

<script>
import M from 'materialize-css'
import api from '@/api'
import BodyShape from '@/components/athlete/BodyShape'
import Training from '@/components/athlete/Training'
import Infos from '@/components/athlete/Infos'

export default {
  name: 'athlete',
  props: ['tab'],
  components: { BodyShape, Training, Infos },
  data: function () {
    return {
      user: undefined
    }
  },
  created () {
    this.user = api.getCurrentUser()
  },
  mounted () {
    var tabs = M.Tabs.init(this.$refs.tabs, {})
    if (this.tab) tabs.select(this.tab)
  }
}
</script>




// WEBPACK FOOTER //
// src/components/Athlete.vue